import {
  HomeComponent,
  UserManagmentRouteComponent,
  ProfileManagementRouteComponent,
  ProfileManagmentComponent,
  UsersListComponent,
  UserInviteComponent,
  UserDetailsComponent,
  ResourcesComponent,
  AllDocumentsComponent,
  MyDocumentsComponent,
  UploadDocumentComponent,
  DocumentComponent,
  ExistingDocumentComponent,
  DocumentDetailComponent,
  SharedDocumentsComponent,
  ApprovalsComponent,
  UserGroupsComponent,
  AddGroupComponent,
  GroupDetailComponent,
  ShareDocumentComponent,
  InboxComponent,
  ComposeMessageComponent,
  ChangePasswordComponent,
  ListingTagsComponent,
  ListCapabilitiesComponent,
  TemplateManagementRouteComponent,
  TemplatesListComponent,
  EditTemplateComponent,
  MoveFilesComponent,
  DocumentListComponent,
  TagsApprovalComponent,
  AddRoleComponent,
  EditRoleComponent,
  ListConfigurationsComponent,
  ManageNotificationsComponent,
  ModifyReplacementPatternComponent,
  AccessRequestComponent,
  ListComponent,
  ViewLogsComponent
} from './index';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { TagsDialogComponent } from 'src/app/dialogs/tags-dialog/tags-dialog.component';
import { UserProfileComponent } from './profile/user-profile.component';
import { ChangeOwnerDialogComponent } from './tasks/change-owner/change-owner.component';
import { NoAccessComponent } from './no-access/no-access.component';
import { MemberGrpListComponent } from './private-members/member-grp-list/member-grp-list.component';
import { AddMemberGroupComponent } from './private-members/add-member-group/add-member-group.component';
import { PrivateMemberGroupDetailComponent } from './private-members/private-member-group-detail/private-member-group-detail.component';
import { UserBulkInviteComponent } from './user-management/user-bulk-invite/user-bulk-invite.component';
import { UserMessagesComponent } from './user-messages/UserMessages.component';
import { ReplaceDocumentComponent } from './resources/replace-document/replace-document.component';
import { UserLogComponent } from './user-management/user-log/user-log.component';
import { TagsActivityComponent } from './tags/listing-tags/tags-activity/tags-activity.component';
import { DocActivityLogComponent } from './resources/doc-activity-log/doc-activity-log.component';
// import { EventFormSubmissionComponent } from './events/event-form-submission/event-form-submission.component';





export const homeRoutes = [
  // {
  //   path: 'profile',
  //   component: ProfileManagementRouteComponent,
  //   data: {
  //     permissions: {
  //       only: 'all',
  //     },
  //   }
  // },
  {
    path: '',
    component: HomeComponent,
    children: [
      // {
      //   path: '',
      //   redirectTo: 'user-management',
      //   pathMatch: 'full'
      // },
      {
        path: 'profile',
        component: UserProfileComponent,
        canActivate: [NgxPermissionsGuard],
        children: [
          { path: '', redirectTo: 'edit', pathMatch: 'full' },
          { path: 'edit', component: ProfileManagmentComponent },
          { path: 'edit/:id', component: ProfileManagmentComponent },
          { path: 'change-password', component: ChangePasswordComponent },
          { path: 'change-password/:id', component: ChangePasswordComponent }
        ]
      },
      {
        path: 'user-management',
        component: UserManagmentRouteComponent,
        data: {
          permissions: {
            only: ["activate-deactivate-user", "bulk-invite", "edit-user-profile", "change-user-role", "create-user", "replace-user"],
            redirectTo: '/home/program-dashboard'
          },
        },
        canActivate: [NgxPermissionsGuard],
        children: [
          { path: '', redirectTo: 'users-list', pathMatch: 'full' },
          { path: 'users-list', component: UsersListComponent },
          { path: 'invite-user', component: UserInviteComponent },
          { path: 'bulk-invite-user', component: UserBulkInviteComponent },
          { path: 'edit-user/:id', component: UserInviteComponent },
          { path: 'details/:id', component: UserDetailsComponent },
          { path: 'user-activity/:id', component: UserLogComponent },
        ]
      },
      {
        path: 'resources',
        children: [
          {
            path: '',
            component: ResourcesComponent,
            children: [
              { path: '', redirectTo: 'me', pathMatch: 'full' },
              { path: 'list', component: AllDocumentsComponent },
              { path: 'me', component: MyDocumentsComponent },
              { path: 'me/:id', component: MyDocumentsComponent },
              { path: 'me/citis/:id', component: MyDocumentsComponent },
              { path: 'approval', component: ApprovalsComponent },
              { path: 'shared-with-me', component: SharedDocumentsComponent },
              { path: 'published-documents', component: AllDocumentsComponent },
              { path: 'all', component: AllDocumentsComponent },
            ]
          },
          { path: 'docs/suggested-tags/:id', component: TagsApprovalComponent },
          { path: 'docs/suggested-tags/:id/remove', component: TagsApprovalComponent },
          { path: 'upload-document', component: UploadDocumentComponent },
          { path: 'upload-document/:id', component: UploadDocumentComponent },
          { path: 'upload-document/citiis/:id', component: UploadDocumentComponent },
          { path: 'update-document', component: ExistingDocumentComponent },
          { path: 'update-document/:documentId', component: UploadDocumentComponent },
          { path: 'add-version/:documentId/:currentVersion/:action', component: UploadDocumentComponent },
          { path: 'doc/:documentId/:action', component: UploadDocumentComponent },
          { path: 'doc/:documentId/:action/:folderId', component: UploadDocumentComponent },
          { path: 'doc/:documentId', component: DocumentDetailComponent },
          { path: 'doc/:documentId/detail/citiis/:folderId', component: DocumentDetailComponent },
          { path: 'share-document', component: ShareDocumentComponent },
          { path: 'move-files', component: MoveFilesComponent },
          { path: 'docs/request-access/:id', component: AccessRequestComponent },
          { path: 'replace-doc/:documentId/:replaceDocId', component: ReplaceDocumentComponent },
          { path: 'citis-replace-doc/:documentId/:replaceDocId/:folderId', component: ReplaceDocumentComponent },
          { path: 'citiis/activity-log/:folderId', component: DocActivityLogComponent },
        ],
      },
      {
        path: 'program-dashboard',
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: ['view-my-project', 'view-all-projects', 'manage-project'],
            redirectTo: 'home/resources'
          },
        },
        loadChildren: './program-dashboard/program-dashboard.module#ProgramDashboardModule'
      },
      {
        path: 'monitoring-evaluation',
        loadChildren: './monitoring-evaluation/monitoring-evaluation.module#MonitoringEvaluationModule'
      },
      {
        path: 'contract-management',
        // canActivate: [NgxPermissionsGuard],
        // data: {
        //   permissions: {
        //     only: ['view-my-project', 'view-all-projects', 'manage-project'],
        //     redirectTo: 'home/resources'
        //   },
        // },
        loadChildren: '../contract-management/contract-management.module#ContractManagementModule'
      },
      {
        path: 'entity-management',
        // canActivate: [NgxPermissionsGuard],
        // data: {
        //   permissions: {
        //     only: ['view-my-project', 'view-all-projects', 'manage-project'],
        //     redirectTo: 'home/resources'
        //   },
        // },
        loadChildren: '../entity-management/entity-management.module#EntityManagementModule'
      },
      {
        path: 'user-groups',
        children: [
          { path: '', component: UserGroupsComponent },
          { path: 'add-group', component: AddGroupComponent },
          { path: ':id', component: GroupDetailComponent },
          { path: ':id/view', component: GroupDetailComponent }
        ],
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: ['create-group', 'edit-group', 'deactivate-group', 'view-all-groups'],
            redirectTo: 'home/user-management'
          },
        }
      },
      {
        path: 'private-members',
        children: [
          { path: '', component: MemberGrpListComponent },
          { path: 'add-member-group', component: AddMemberGroupComponent },
          { path: ':id', component: PrivateMemberGroupDetailComponent }
        ],
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: ['manage-private-group'],
            redirectTo: '/home/user-management'
          }
        }
      },
      // {
      //   path: 'notification-modal', component: NotificationModalComponent
      // },
      {
        path: 'tasks',
        loadChildren: './tasks/tasks.module#TasksModule'
      },
      {
        path: 'events',
        loadChildren: './events/events.module#EventsModule'
      },
      {
        path: 'budget',
        loadChildren: './budget/budget.module#BudgetModule'
      },
      {
        path: 'procurement',
        loadChildren: './procurement/procurement.module#ProcurementModule'
      },   
      {
        path: 'challenge',
        loadChildren: './challenge/challenge.module#ChallengeModule'
      },  
      {
        path: 'messages',
        component: UserMessagesComponent,

        children: [
          { path: '', redirectTo: 'my-messages', pathMatch: 'full' },
          { path: 'my-messages', component: InboxComponent },
          { path: 'all-cmp-messages', component: InboxComponent },
          { path: 'compose-message', component: ComposeMessageComponent },
          { path: 'inbox/:userId', component: InboxComponent }
        ]
      },
      {
        path: 'tags',
        children: [
          { path: '', redirectTo: 'list-tags', pathMatch: 'full' },
          { path: 'list-tags', component: ListingTagsComponent },
          { path: 'tags-activity', component: TagsActivityComponent },
        ]
      },
      {
        path: 'templates',
        component: TemplateManagementRouteComponent,
        canActivate: [NgxPermissionsGuard],
        children: [
          { path: '', redirectTo: 'template-list', pathMatch: 'full' },
          { path: 'template-list', component: TemplatesListComponent },
          { path: 'edit-template/:id', component: EditTemplateComponent },
          { path: 'replacement-pattern', component: ModifyReplacementPatternComponent }
        ]
      },
      {
        path: 'role-management',
        canActivate: [NgxPermissionsGuard],
        children: [
          { path: '', redirectTo: 'list-capabilities', pathMatch: 'full' },
          { path: 'list-capabilities', component: ListCapabilitiesComponent },
          { path: 'add-role', component: AddRoleComponent },
          { path: 'edit-role', component: EditRoleComponent },
          { path: 'view-logs', component: ViewLogsComponent },
        ],
        data: {
          permissions: {
            only: ['display-role-management'],
            redirectTo: '/home/user-management'
          }
        }
      },
      {
        path: 'configurations',
        children: [
          { path: '', redirectTo: 'list-configurations', pathMatch: 'full' },
          { path: 'list-configurations', component: ListConfigurationsComponent },
          //   { path: 'add-role', component: AddRoleComponent },
          //   { path: 'edit-role', component: EditRoleComponent },
        ]
      },
      {
        path: 'notifications',
        children: [
          { path: '', redirectTo: 'manage-notifications', pathMatch: 'full' },
          {
            path: 'manage-notifications', component: ManageNotificationsComponent,
            canActivate: [NgxPermissionsGuard],
            data: {
              permissions: {
                only: ['notification-management'],
                redirectTo: '/home/user-management'
              }
            }
          }
        ]
      },
      {
        path: 'web-notifications',
        children: [
          { path: '', redirectTo: 'web-notifications', pathMatch: 'full' },
          { path: 'list-notifications', component: ListComponent }
        ]
      },
      // {
      //   path:"details/:id",
      //   component: EventFormSubmissionComponent
      // },
      { path: 'no-access', component: NoAccessComponent }
    ]
  }
];

export const HOME_DECLARATIONS = [
  HomeComponent,
  UserManagmentRouteComponent,
  ProfileManagementRouteComponent,
  ProfileManagmentComponent,
  UsersListComponent,
  UserInviteComponent,
  ResourcesComponent,
  AllDocumentsComponent,
  MyDocumentsComponent,
  UploadDocumentComponent,
  DocumentComponent,
  ApprovalsComponent,
  ExistingDocumentComponent,
  DocumentDetailComponent,
  UserGroupsComponent,
  AddGroupComponent,
  GroupDetailComponent,
  ShareDocumentComponent,
  SharedDocumentsComponent,
  InboxComponent,
  ComposeMessageComponent,
  UserProfileComponent,
  ChangePasswordComponent,
  ListingTagsComponent,
  UserDetailsComponent,
  ListCapabilitiesComponent,
  ChangeOwnerDialogComponent,
  TemplateManagementRouteComponent,
  TemplatesListComponent,
  EditTemplateComponent,
  MoveFilesComponent,
  NoAccessComponent,
  DocumentListComponent,
  TagsApprovalComponent,
  AddRoleComponent,
  EditRoleComponent,
  ListConfigurationsComponent,
  AccessRequestComponent,
  UserMessagesComponent,
];
